<template>
  <div class="horizontal"></div>
</template>

<script>
export default {
  components: {
    // 'render-title':
  },
  props: {
    config: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {}
};
</script>

<style lang="scss" scoped>
@import '../../../assets/scss/standard';

.horizontal {
  height: 1px;
  margin: sizeTrans($space_20) 0;
  border-bottom: 1px solid $color_mb5_front;
  box-sizing: border-box;
}
</style>